module.exports = __webpack_public_path__ + "static/media/posted-logo-full-white.d212e7e4.png";